import { Filter, FilterKey } from 'api-paths-cas';
import { IGetFilterGroupsProps } from '../../types';
import { hasPerm, P } from '@/utilities/roles/permissions';

const key = FilterKey.DEPENDANTS;
const list = [
  { label: 'Partner only', value: 'partner-only' },
  { label: 'Children only', value: 'children-only' },
  { label: 'Partner or children', value: 'partner-or-children' },
  { label: 'Partner and children', value: 'partner-and-children' },
  { label: 'None', value: 'none' },
];
export const getDependantsFilter = ({ activeFilters, userRole }: IGetFilterGroupsProps): Filter | null => {
  let canFilterDependants;

  if (userRole) {
    canFilterDependants = hasPerm(userRole, P.FILTER_DEPENDANTS);
  }

  if (!canFilterDependants) {
    return null;
  }

  const selectedValue = activeFilters?.[key]?.[0] ?? '';
  return {
    name: 'Dependants',
    key,
    showSearch: false,
    options: {
      SELECT_ONE: list.map(item => {
        return {
          value: item.value,
          label: item.label,
          checked: selectedValue === item.value,
        };
      }),
    },
  };
};
